<template>
  <CommonPages id="terms-of-service" :class="['resources-page']" titlePrefix="Terms of Service"
    :metaDescription="domainConfig?.['meta']?.des || 'Terms of Service'">

    <div class="resources-row">
      <div class="resources">
        <!-- 页面主标题 -->
        <h2 class="resources__title">Terms of Service</h2>

        <div class="resources__content">
          <p>
            Welcome to {{ domainConfig?.siteName }}. By accessing or using our website, you agree to comply with and be bound by the following Terms of Service. Please read them carefully.
          </p>
        </div>

        <h3 class="resources__subtitle">1. Acceptance of Terms</h3>
        <div class="resources__content">
          <p>
            By using {{ domainConfig?.siteName }}, you confirm that you have read, understood, and agreed to be bound by these terms. If you do not agree, please do not use our services.
          </p>
        </div>

        <h3 class="resources__subtitle">2. Nature of Content (AI-Generated Content)</h3>
        <div class="resources__content">
          <p><strong>AI Origin:</strong> You acknowledge that the novels and stories on this platform are primarily generated by Artificial Intelligence (AI) algorithms.</p>
          <p><strong>Fictional Nature:</strong> All content is for entertainment purposes only. Any resemblance to real persons (living or dead), actual events, or locales is purely coincidental.</p>
          <p><strong>Accuracy Disclaimer:</strong> AI-generated content may occasionally contain factual inaccuracies, logical inconsistencies, or unconventional narrative structures. We do not guarantee the absolute coherence or accuracy of any story.</p>
        </div>

        <h3 class="resources__subtitle">3. Intellectual Property Rights</h3>
        <div class="resources__content">
          <p><strong>Platform Ownership:</strong> All AI-generated content, website design, text, and graphics are the property of {{ domainConfig?.siteName }} unless otherwise stated.</p>
          <p><strong>User License:</strong> We grant you a personal, non-exclusive, non-transferable license to access and read the content for personal, non-commercial use only.</p>
          <p><strong>Prohibitions:</strong> You may not scrape, redistribute, sell, or use our AI-generated stories to train other machine learning models without explicit written consent from us.</p>
        </div>

        <h3 class="resources__subtitle">4. User Conduct</h3>
        <div class="resources__content">
          <p>You agree not to:</p>
          <ul>
            <li>Use the site for any unlawful purpose.</li>
            <li>Attempt to disrupt the website’s functionality or bypass security measures.</li>
            <li>Use automated bots or scrapers to harvest content from the site.</li>
          </ul>
        </div>

        <h3 class="resources__subtitle">5. Disclaimer of Warranties</h3>
        <div class="resources__content">
          <p>
            {{ domainConfig?.siteName }} is provided on an "as is" and "as available" basis. We make no warranties, expressed or implied, regarding the availability, reliability, or quality of the AI-generated novels. We are not responsible for any offense taken due to the unpredictable nature of AI-generated plots.
          </p>
        </div>

        <h3 class="resources__subtitle">6. Limitation of Liability</h3>
        <div class="resources__content">
          <p>
            To the maximum extent permitted by law, {{ domainConfig?.siteName }} shall not be liable for any indirect, incidental, or consequential damages arising from your use of the service or the content provided.
          </p>
        </div>

        <h3 class="resources__subtitle">7. Changes to Terms</h3>
        <div class="resources__content">
          <p>
            We reserve the right to modify these terms at any time. We will notify users of any significant changes by posting the new terms on this page. Your continued use of the site after changes are made constitutes acceptance of those changes.
          </p>
        </div>

        <h3 class="resources__subtitle">8. Contact Us</h3>
        <div class="resources__content">
          <p>
            If you have any questions about these Terms, please contact us at: {{ domainConfig?.IAMEMAIL }}.
          </p>
        </div>
      </div>
    </div>

  </CommonPages>
</template>

<script>
import CommonPages from '@/pages/components/page_common.vue'
import { mapGetters } from 'vuex'
import '@/css/resources.scss'

export default {
  name: 'TermsOfService',
  components: {
    CommonPages
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig'
    ])
  }
}
</script>
